/* eslint-disable no-useless-escape */
export function isValidUrl(url: string): boolean {
  const regex =
    /^(?:http(s)?:\/\/)?(?:localhost|[\w.-]+(?:\.[\w\.-]+)+)(?:[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+)?$/;

  return regex.test(url);
}
